import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import TdsSectionEntry from "../../components/masters/tdssection/TdsSectionEntry";
import TdsSectionList from "../../components/masters/tdssection/TdsSectionList";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import commonUtility from "../../utility/Utils";

const TdsSection = () => {
  const [visible, setVisible] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [tdsSectionAddData, setTdsSectionAddData] = useState({
    tdsId: 0,
    tds_desc: '',
    tds_rate: '',
    is_active: 'Y',
    mode: ADD_MODE
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const onRefreshList = () => {
    setRefreshTrigger(prev => prev + 1);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="TDS Section"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            // <Button key="2" className="custom-button-white" shape="round" size="medium" disabled>
            //   <FileExcelOutlined /> Excel
            // </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new TDS"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <TdsSectionEntry data={tdsSectionAddData} onDrawerClose={onClose} onRefreshList={onRefreshList} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            <TdsSectionList refreshTrigger={refreshTrigger} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TdsSection